import { AdminScopeType } from '../models/AdminScope';
import { Order } from '../models/Order';
import { Store } from '../models/Store';

export type ScopeStoreSelection = {
  activeScopeType: AdminScopeType;
  selectedGroupId: string | null;
  selectedStoreId: string | null;
  stores: Store[];
};

export const resolveScopedStoreIds = ({
  activeScopeType,
  selectedGroupId,
  selectedStoreId,
  stores,
}: ScopeStoreSelection): string[] | null => {
  if (selectedStoreId) {
    return selectedStoreId ? [selectedStoreId] : [];
  }

  if (selectedGroupId) {
    return stores
      .filter((store) => store.operationGroupId === selectedGroupId)
      .map((store) => store.id);
  }

  if (activeScopeType === 'global') {
    return null;
  }

  if (activeScopeType === 'store' || activeScopeType === 'group') {
    return [];
  }

  return null;
};

export const filterOrdersByStoreScope = (orders: Order[], storeIds: string[] | null): Order[] => {
  if (storeIds === null) {
    return orders;
  }

  if (storeIds.length === 0) {
    return [];
  }

  const allowed = new Set(storeIds);
  return orders.filter((order) => allowed.has(order.storeId));
};

export const describeActiveScope = ({
  activeScopeType,
  selectedGroupId,
  selectedStoreId,
  stores,
}: ScopeStoreSelection): string => {
  if (selectedStoreId) {
    const store = stores.find((item) => item.id === selectedStoreId);
    return store ? `Magasin: ${store.name}` : 'Magasin non sélectionné';
  }

  if (selectedGroupId) {
    const scopedStores = stores.filter((store) => store.operationGroupId === selectedGroupId);
    if (scopedStores.length === 0) {
      return 'Groupe non sélectionné';
    }

    return `Groupe: ${scopedStores.length} magasin(s)`;
  }

  if (activeScopeType === 'global') {
    return 'Réseau global';
  }

  if (activeScopeType === 'group') {
    return 'Groupe non sélectionné';
  }

  return 'Magasin non sélectionné';
};
